import { render, staticRenderFns } from "./button.vue?vue&type=template&id=7cdbc56a&scoped=true&"
import script from "./button.vue?vue&type=script&lang=js&"
export * from "./button.vue?vue&type=script&lang=js&"
import style0 from "./button.vue?vue&type=style&index=0&id=7cdbc56a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cdbc56a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7cdbc56a')) {
      api.createRecord('7cdbc56a', component.options)
    } else {
      api.reload('7cdbc56a', component.options)
    }
    module.hot.accept("./button.vue?vue&type=template&id=7cdbc56a&scoped=true&", function () {
      api.rerender('7cdbc56a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/controls/button.vue"
export default component.exports